<template>
  <div>
    <div class="row">
      <div class="col-3 mb-2">
        <button v-if="workers" @click="getReport" class="btn orcaBtn greenBtn">Download CSV</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <datatable :type="'workers'" :rowData="workers" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"></datatable>
      </div>
    </div>
  </div>
</template>
<script>
import datatable from "datatables/datatable";

export default {
  name: 'all_tax_workers',
  components: {datatable},
  data() {
    return {
      workers: null,
      loadingMessage: 'Loading Tax Service Workers...',
      noRowsMessage: 'No Tax Service Workers Found',
      columns: [
        {headerName: 'Ref', field: 'internal_finance_ref', width: 80, pinned: 'left', suppressSizeToFit: true},
        {headerName: 'Name', minWidth: 150, pinned: 'left', suppressSizeToFit: true, valueGetter: this.full_name_vg},
        {headerName: 'Email', minWidth: 200, suppressSizeToFit: true, valueGetter: this.login_email_vg},
        {headerName: 'Mobile', minWidth: 100, suppressSizeToFit: true, valueGetter: this.mobile_vg},
        {headerName: 'Working For', field: 'last_assignment.company_name', minWidth: 200, suppressSizeToFit: true},
        {headerName: 'UTR No', field: 'rel_profile.personal_utr_number', minWidth: 100, suppressSizeToFit: true},
        {headerName: 'Sign Up', minWidth: 100, valueGetter: this.sign_up_date_value_getter, suppressSizeToFit: true},
        {headerName: 'Commission', minWidth: 150, suppressSizeToFit: true, valueGetter: this.commission_user_vg},
        {headerName: 'Initial Docs Sent', minWidth: 150, valueGetter: this.docs_sent_date_value_getter, suppressSizeToFit: true},
        {headerName: 'Terms Engagement Received', minWidth: 175, valueGetter: this.received_terms_engagement_date_value_getter, suppressSizeToFit: true},
        {headerName: 'Self Assessment Declaration Received', minWidth: 180, valueGetter: this.received_self_ass_dec_form_date_value_getter, suppressSizeToFit: true},
        {headerName: 'HMRC 64/8 Received', minWidth: 130, valueGetter: this.received_hmrc_648_date_value_getter, suppressSizeToFit: true},
        {headerName: '64/8 Sent To HMRC', minWidth: 130, valueGetter: this.sent_hmrc_648_date_value_getter, suppressSizeToFit: true},
        {headerName: 'HMRC Authorisation Received', minWidth: 180, valueGetter: this.received_auth_code_date_value_getter, suppressSizeToFit: true},
        {headerName: 'HMRC Authorisation Code', field: 'rel_tax_genius.received_auth_code', minWidth: 170, suppressSizeToFit: true}
      ]
    }
  },
  mounted() {
    this.get_workers();
  },
  methods: {
    get_workers() {
      axios.get(this.crmApiPath + 'worker/tax_genius/index').then(workers => this.workers = workers.data).catch(error => console.error(error.message));
    },
    getReport() {
        if(this.workers) {
          this.exportToCsv(this.workers);
        } 
    },
    exportToCsv(data) {
      const headers = ['Ref', 'Name', 'Email', 'Mobile', 'Working For','UTR Number', 'Sign Up', 'Commision', 'Initial Docs Sent', 'Terms Enagagment Received', 'Self Assesments Declaration Rec.', 'HMRC 64/8 Rec.', '64/8 Sent To HMRC', 'HMRC Auth. Rec.', 'HMRC Authorisation Code'];
      let rows = [];

      data.forEach(worker => {

        // re-assign worker to data property. This is a tweak so we could utilize existing functions from this component
        let params = {data: worker};
        let row = [];
        row.push(worker.internal_finance_ref);
        row.push(this.full_name_vg(params));
        row.push(this.login_email_vg(params));
        row.push(this.mobile_vg(params));
        row.push(this.last_assignment_getter(params));
        row.push(this.utr_number_getter(params));
        row.push(this.sign_up_date_value_getter(params));
        row.push(this.commission_user_vg(params));
        row.push(this.docs_sent_date_value_getter(params));
        row.push(this.received_terms_engagement_date_value_getter(params));
        row.push(this.received_self_ass_dec_form_date_value_getter(params));
        row.push(this.received_hmrc_648_date_value_getter(params));
        row.push(this.sent_hmrc_648_date_value_getter(params));
        row.push(this.received_auth_code_date_value_getter(params));
        row.push(worker.rel_tax_genius.received_auth_code);

        rows.push(row);
      });

      const csvContent = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'all_workers_report.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    full_name_vg(params) {
      return params.data.person.first_name + ' ' + params.data.person.surname;
    },
    login_email_vg(params) {
      // website login email
      let temp = params.data.rel_emails.find(re => re.email_type_id === 67);
      if (temp !== undefined) {
        return temp.email_address;
      }
    },
    mobile_vg(params) {
      // personal mobile number
      let temp = params.data.rel_phones.find(rp => rp.phone_type_id === 59);
      if (temp !== undefined) {
        return temp.phone_number;
      }
    },
    sign_up_date_value_getter(params) {
      if (params.data.rel_tax_genius.signup_date !== null) {
        return this.$options.filters.formatDate(params.data.rel_tax_genius.signup_date);
      }
      else {
        return params.data.rel_tax_genius.signup_date
      }
    },
    last_assignment_getter(params) {
      if (params.data.last_assignment !== null) {
        return params.data.last_assignment.company_name;
      }

      return null;
    },
    utr_number_getter(params) {
      if (params.data.rel_profile.personal_utr_number !== null) {
        return params.data.rel_profile.personal_utr_number;
      }

      return null;
    },
    commission_user_vg(params) {
      if (params.data.rel_tax_genius.commission_user_id !== null) {
        return params.data.rel_tax_genius.commission_user.first_name + ' ' + params.data.rel_tax_genius.commission_user.surname;
      }
    },
    docs_sent_date_value_getter(params) {
      if (params.data.rel_tax_genius.docs_sent_date !== null) {
        return this.$options.filters.formatDate(params.data.rel_tax_genius.docs_sent_date);
      }
      else {
        return params.data.rel_tax_genius.docs_sent_date
      }
    },
    received_terms_engagement_date_value_getter(params) {
      if (params.data.rel_tax_genius.received_terms_engagement_date !== null) {
        return this.$options.filters.formatDate(params.data.rel_tax_genius.received_terms_engagement_date);
      }
      else {
        return params.data.rel_tax_genius.received_terms_engagement_date
      }
    },
    received_self_ass_dec_form_date_value_getter(params) {
      if (params.data.rel_tax_genius.received_self_ass_dec_form_date !== null) {
        return this.$options.filters.formatDate(params.data.rel_tax_genius.received_self_ass_dec_form_date);
      }
      else {
        return params.data.rel_tax_genius.received_self_ass_dec_form_date;
      }
    },
    received_hmrc_648_date_value_getter(params) {
      if (params.data.rel_tax_genius.received_hmrc_648_date !== null) {
        return this.$options.filters.formatDate(params.data.rel_tax_genius.received_hmrc_648_date);
      }
      else {
        return params.data.rel_tax_genius.received_hmrc_648_date;
      }
    },
    sent_hmrc_648_date_value_getter(params) {
      if (params.data.rel_tax_genius.sent_hmrc_648_date !== null) {
        return this.$options.filters.formatDate(params.data.rel_tax_genius.sent_hmrc_648_date);
      }
      else {
        return params.data.rel_tax_genius.sent_hmrc_648_date;
      }
    },
    received_auth_code_date_value_getter(params) {
      if (params.data.rel_tax_genius.received_auth_code_date !== null) {
        return this.$options.filters.formatDate(params.data.rel_tax_genius.received_auth_code_date);
      }
      else {
        return params.data.rel_tax_genius.received_auth_code_date;
      }
    }
  },
}
</script>
